<div
  class="checkbox mdc-checkbox"
  [class.checkbox--has-focus]="hasFocus"
  cdkMonitorSubtreeFocus
  (cdkFocusChange)="onFocusChange($event)"
>
  <input
    type="checkbox"
    class="mdc-checkbox__native-control"
    [id]="id"
    [tabIndex]="tabIndex"
    [checked]="isChecked"
    [disabled]="disabled ? true : null"
    (change)="onChange($event)"
    #inputElement
  />

  <div class="mdc-checkbox__background">
    <svg class="mdc-checkbox__checkmark" width="24" viewBox="0 0 24 24">
      <path
        class="mdc-checkbox__checkmark-path"
        fill="none"
        d="M1.73,12.91 8.1,19.28 22.79,4.59"
      ></path>
    </svg>

    <div class="mdc-checkbox__mixedmark"></div>
  </div>

  <div class="mdc-checkbox__ripple"></div>
</div>
